export const VALIDATION_STATUS = {
  VALID: 'valid',
  INVALID: 'invalid',
  CHECKING: 'checking',
  EMPTY: ''
};

export const ACCOUNT_TYPES = {
  MONTHLY: 'monthly',
  PPV: 'ppv'
};

export const SUBSCRIPTION_TYPES = {
  CONTENT_CREATOR: 'content-creator',
  PPV_CREATOR: 'ppv-creator'
};

export const DOCUMENT_TYPES = {
  ID: 'id',
  PASSPORT: 'passport'
};

export const FILE_TYPES = {
  PROFILE_IMAGE: 'profileImage',
  ID_FRONT: 'idFront',
  ID_BACK: 'idBack'
};

/**
 * Gets subscription type based on account type
 * @param {string} accountType - The account type (monthly/ppv)
 * @returns {string} The subscription type
 */
export const getSubscriptionType = (accountType) => {
  return accountType === ACCOUNT_TYPES.MONTHLY
    ? SUBSCRIPTION_TYPES.CONTENT_CREATOR
    : SUBSCRIPTION_TYPES.PPV_CREATOR;
};

/**
 * Gets image data based on document type
 * @param {string} documentType - The document type (id/passport)
 * @param {Object} uploadedFiles - The uploaded files object
 * @returns {Object} Image data object
 */
export const getImageData = (documentType, uploadedFiles) => {
  if (documentType === DOCUMENT_TYPES.ID) {
    return {
      profileImage: uploadedFiles[FILE_TYPES.PROFILE_IMAGE]?.base64 || "",
      idFront: uploadedFiles[FILE_TYPES.ID_FRONT]?.base64 || "",
      idBack: uploadedFiles[FILE_TYPES.ID_BACK]?.base64 || ""
    };
  } else {
    return {
      profileImage: uploadedFiles[FILE_TYPES.PROFILE_IMAGE]?.base64 || "",
      idFront: uploadedFiles[FILE_TYPES.ID_FRONT]?.base64 || "",
      idBack: ""
    };
  }
};